import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-form-link-video',
  templateUrl: './form-link-video.component.html',
  styleUrls: ['./form-link-video.component.scss']
})
export class FormLinkVideoComponent implements OnInit {
  
  playerLoaded = false;
  urlError = false;
  @Input() url:string = '';
  @Output() urlEmit = new EventEmitter<string>();
  @Output() deleteUrlEmit = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  deleteVideo(){
    this.url = '';
    this.deleteUrlEmit.emit()
  }


  changeVideoLink(){
    this.urlError = this.linkValidate;
    if( !this.urlError ) this.urlEmit.emit(this.url);
  }

  get linkValidate(){
    const pattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([\/\w .-]*)*\/?$/;
    return !pattern.test(this.url);
  }
}
